const FormatDate = (inputDate) => {
    const options = { day: '2-digit', month: '2-digit', year: 'numeric' };
    return new Date(inputDate).toLocaleDateString('fr', options);
};

export default FormatDate;
